
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired9b2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired9b2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("egFgR", function(module, exports) {
module.exports = import("ksv24").then(()=>parcelRequire('cbfsI'));

});

parcelRegister("fcnwe", function(module, exports) {
module.exports = import("6sb12").then(()=>parcelRequire('hQfKz'));

});

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = globalThis, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$o = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(o, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3233927aa82734f9$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3233927aa82734f9$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $27fcf98b67c2a783$var$i, defineProperty: $27fcf98b67c2a783$var$e, getOwnPropertyDescriptor: $27fcf98b67c2a783$var$h, getOwnPropertyNames: $27fcf98b67c2a783$var$r, getOwnPropertySymbols: $27fcf98b67c2a783$var$o, getPrototypeOf: $27fcf98b67c2a783$var$n } = Object, $27fcf98b67c2a783$var$a = globalThis, $27fcf98b67c2a783$var$c = $27fcf98b67c2a783$var$a.trustedTypes, $27fcf98b67c2a783$var$l = $27fcf98b67c2a783$var$c ? $27fcf98b67c2a783$var$c.emptyScript : "", $27fcf98b67c2a783$var$p = $27fcf98b67c2a783$var$a.reactiveElementPolyfillSupport, $27fcf98b67c2a783$var$d = (t, s)=>t, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, s)=>!$27fcf98b67c2a783$var$i(t, s), $27fcf98b67c2a783$var$b = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $27fcf98b67c2a783$var$a.litPropertyMetadata ??= new WeakMap;
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $27fcf98b67c2a783$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $27fcf98b67c2a783$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $27fcf98b67c2a783$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $27fcf98b67c2a783$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("elementProperties"))) return;
        const t = $27fcf98b67c2a783$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($27fcf98b67c2a783$var$d("properties"))) {
            const t = this.properties, s = [
                ...$27fcf98b67c2a783$var$r(t),
                ...$27fcf98b67c2a783$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $27fcf98b67c2a783$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("elementProperties")] = new Map, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("finalized")] = new Map, $27fcf98b67c2a783$var$p?.({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), ($27fcf98b67c2a783$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = (t)=>t, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$h = "$lit$", $e5ed8027d647799b$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$n = "?" + $e5ed8027d647799b$var$o, $e5ed8027d647799b$var$r = `<${$e5ed8027d647799b$var$n}>`, $e5ed8027d647799b$var$l = document, $e5ed8027d647799b$var$c = ()=>$e5ed8027d647799b$var$l.createComment(""), $e5ed8027d647799b$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$u = Array.isArray, $e5ed8027d647799b$var$d = (t)=>$e5ed8027d647799b$var$u(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$f = "[ \t\n\f\r]", $e5ed8027d647799b$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$f}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$f}*=${$e5ed8027d647799b$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$x(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$x(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$x(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$C = new WeakMap, $e5ed8027d647799b$var$P = $e5ed8027d647799b$var$l.createTreeWalker($e5ed8027d647799b$var$l, 129);
function $e5ed8027d647799b$var$V(t, i) {
    if (!$e5ed8027d647799b$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(i) : i;
}
const $e5ed8027d647799b$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $e5ed8027d647799b$var$v ? "!--" === u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[1] ? c = $e5ed8027d647799b$var$m : void 0 !== u[2] ? ($e5ed8027d647799b$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$p) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$p ? ">" === u[0] ? (c = n ?? $e5ed8027d647799b$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$p : '"' === u[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : c === $e5ed8027d647799b$var$$ || c === $e5ed8027d647799b$var$g ? c = $e5ed8027d647799b$var$p : c === $e5ed8027d647799b$var$_ || c === $e5ed8027d647799b$var$m ? c = $e5ed8027d647799b$var$v : (c = $e5ed8027d647799b$var$p, n = void 0);
        const x = c === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$v ? s + $e5ed8027d647799b$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $e5ed8027d647799b$var$h + s.slice(d) + $e5ed8027d647799b$var$o + x) : s + $e5ed8027d647799b$var$o + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$N(t, i);
        if (this.el = $e5ed8027d647799b$var$S.createElement(f, e), $e5ed8027d647799b$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$I : "?" === e[1] ? $e5ed8027d647799b$var$L : "@" === e[1] ? $e5ed8027d647799b$var$z : $e5ed8027d647799b$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$y.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $e5ed8027d647799b$var$c()), $e5ed8027d647799b$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $e5ed8027d647799b$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $e5ed8027d647799b$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$M(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$l).importNode(i, !0);
        $e5ed8027d647799b$var$P.currentNode = e;
        let h = $e5ed8027d647799b$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $e5ed8027d647799b$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $e5ed8027d647799b$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $e5ed8027d647799b$var$P.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$P.currentNode = $e5ed8027d647799b$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$M(this, t, i), $e5ed8027d647799b$var$a(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$S.createElement($e5ed8027d647799b$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$C.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$C.set(t.strings, i = new $e5ed8027d647799b$var$S(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$k(this.O($e5ed8027d647799b$var$c()), this.O($e5ed8027d647799b$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $e5ed8027d647799b$var$i(t).nextSibling;
            $e5ed8027d647799b$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$M(this, t, i, 0), o = !$e5ed8027d647799b$var$a(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$M(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$a(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$z extends $e5ed8027d647799b$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$M(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$M(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$h,
    P: $e5ed8027d647799b$var$o,
    A: $e5ed8027d647799b$var$n,
    C: 1,
    L: $e5ed8027d647799b$var$N,
    R: $e5ed8027d647799b$var$R,
    D: $e5ed8027d647799b$var$d,
    V: $e5ed8027d647799b$var$M,
    I: $e5ed8027d647799b$var$k,
    H: $e5ed8027d647799b$var$H,
    N: $e5ed8027d647799b$var$L,
    U: $e5ed8027d647799b$var$z,
    B: $e5ed8027d647799b$var$I,
    F: $e5ed8027d647799b$var$Z
}, $e5ed8027d647799b$var$B = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$B?.($e5ed8027d647799b$var$S, $e5ed8027d647799b$var$k), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.3.3");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$k(i.insertBefore($e5ed8027d647799b$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fe586ba0757c37f7$var$s = globalThis;
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = !0, $fe586ba0757c37f7$var$s.litElementHydrateSupport?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$o = $fe586ba0757c37f7$var$s.litElementPolyfillSupport;
$fe586ba0757c37f7$var$o?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($fe586ba0757c37f7$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $74d80410d825d70d$var$n = "important", $74d80410d825d70d$var$i = " !" + $74d80410d825d70d$var$n, $74d80410d825d70d$export$1e5b4ce2fa884e6a = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ft) return this.ft = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ft)null == r[t] && (this.ft.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ft.add(t);
                const r = "string" == typeof e && e.endsWith($74d80410d825d70d$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $74d80410d825d70d$var$n : "") : s[t] = e;
            }
        }
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});




var $1a8b8fcaadcb0100$exports = {};
$1a8b8fcaadcb0100$exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%221440%22%20height%3D%22560%22%20preserveAspectRatio%3D%22none%22%20viewBox%3D%220%200%201440%20560%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%233379c294%22%20stroke-width%3D%222%22%20mask%3D%22url%28%23SvgjsMask1037%29%22%3E%3Cpath%20d%3D%22M420%2086.8c-39.38%2022.55-73.89%2023.35-73.89%2053.2%200%2034.75%2027.81%2059.11%2073.89%2076%2060.87%2022.31%2087.93%2026.32%20140%202.4%2030.65-14.08%2025.45-38.51%2025.45-78.4%200-60.56%2011.34-110.67-25.45-122.5-45.93-14.77-72.44%2030.6-140%2069.3%22%2F%3E%3Cpath%20d%3D%22M95.79%200c32.45%2016.23%2021.44%2070%2044.21%2070%2023.34%200%2014.41-53.2%2048-70%2036.41-18.2%2046%200%2092%200h140c14.49%200%2028.97-3.9%2028.97%200%200%204.5-14.71%208.03-28.97%2016.8-70.22%2043.17-70.21%2043.2-140%2087.07-28.21%2017.73-56%2020.12-56%2036.13%200%2014.78%2032.7%206.03%2056%2025.45%2060.7%2050.58%2063.06%2052.48%20112%20114.55%2021.06%2026.71.6%2056.97%2028%2063%2056.6%2012.46%2075.28-2.98%20140-26.02%2023.77-8.46%2027.54-13.41%2036.98-36.98%2026.01-64.92%2026.3-69.01%2033.93-140%207.42-69.01-26.55-93.97-3.83-140%2011.83-23.97%2036.46%200%2072.92%200%2030.17%200%2034.28-11.78%2060.34%200C804.28%2019.86%20803.4%2028.27%20840%2063.29c36.56%2034.98%2032.24%2039.37%2066.67%2076.71%2035.57%2038.57%2030.7%2045.73%2073.33%2075.12%2058.91%2040.61%2066.85%2030%20129.76%2064.88%207.09%203.93%203.06%2012.73%2010.24%2012.73%2021.27%200%2040.98%206.88%2046.67-12.73%2016.47-56.76-26.83-81.43-2.34-140%2022.17-53.03%2045.46-44.73%2095.67-83.19%2041.18-31.54%2040.71-37.98%2087.11-56.81%2023.6-9.58%2026.44%200%2052.89%200%2024.79%200%2027.35-8.95%2049.58%200%2047.77%2019.23%2065.09%2017.14%2090.42%2056.36%2019.88%2030.78%200%2041.82%200%2083.64%200%2039.75%2025.34%2066.21%200%2079.51-44.66%2023.45-75-21.97-140-6.01-58.2%2014.29-57.88%2028.13-106.4%2066.5-21.48%2016.98-20.44%2019.95-33.6%2044.21-24.81%2045.74-42.33%2048.5-42.33%2095.79%200%2041.97%206.65%2059.55%2042.33%2082.73%2055.48%2036.05%2074.55%2011.45%20140%2035.73%2011.73%204.35%2014.36%2014.61%2014.36%2021.54%200%203.84-7.18%200-14.36%200H840c-53.15%200-93.61%2029.34-106.3%200-17.58-40.66%2056.07-82.16%2045.76-140-6.54-36.66-42.59-49-79.46-49-27.36%200-28.21%2021.46-49%2049-49.21%2065.21-34.02%20125.95-91%20136.5-58.52%2010.84-78.87-94.75-140-93.72-43.18.72-24.87%2066.83-68.63%2097.22-26.24%2018.22-35.69%200-71.37%200H140c-70%200-105%2035-140%200s0-70%200-140c0-34.24-18.5-44.08%200-68.48%2034.57-45.6%20106.13-32.99%20106.13-71.52%200-41.69-67.37-37.78-106.13-88.92-14.3-18.86%200-25.54%200-51.08C0%2070-28.44%2041.56%200%200c19.46-28.44%2058.24-18.77%2095.79%200%22%2F%3E%3Cpath%20d%3D%22M980%20386.4c-28.41%200-60%2015.96-60%2033.6%200%2018.25%2031.87%2038.18%2060%2038.18%2021.87%200%2040-19.72%2040-38.18%200-17.43-18.41-33.6-40-33.6%22%2F%3E%3Cpath%20d%3D%22M3.68%200c9.1%2068.22%2016.61%2076.68%2014.99%20140-.22%208.57-10.88%203.78-18.67%203.78-1.55%200%200-1.89%200-3.78C0%2070-1.79%2068.21%200%200c.05-1.79%203.44-1.78%203.68%200%22%2F%3E%3Cpath%20d%3D%22M676.36%20140C685.65%2069.67%20663.79%206.37%20700%200c45.61-8.02%2072%2053.53%20140%20111.23%2014.5%2012.3%2025%2011.75%2025%2028.77%200%2037.75-3.47%2045.96-25%2080.77-21.77%2035.19-26.49%2036.18-61.6%2059.23-34.89%2022.9-41.91%2032.67-78.4%2032.67-21.2%200-33.91-10.25-36.98-32.67-8.75-63.91%204.14-70.33%2013.34-140%22%2F%3E%3Cpath%20d%3D%22M1222.67%20140c0-19.31%2015.09-32.46%2037.33-32.46%2052.42%200%20112%209.56%20112%2032.46%200%2025.33-64.57%2064-112%2064-27.24%200-37.33-35.08-37.33-64%22%2F%3E%3Cpath%20d%3D%22M1422.4%20140c0-18.66%2072.67-38.18%20117.6-38.18%2013.87%200%200%2019.09%200%2038.18%200%2018.15%2013.39%2036.3%200%2036.3-45.41%200-117.6-17.72-117.6-36.3%22%2F%3E%3Cpath%20d%3D%22M206.67%20280c15.4-32.08%2039.77-35%2073.33-35%2020.22%200%2025.09%2012.93%2034.22%2035%2027.07%2065.43%2045.76%2072.61%2038.19%20140-8.16%2072.61-34.08%2071.21-69.66%20140-.63%201.21-1.37%200-2.75%200-11.66%200-17.76%209.28-23.33%200-36.43-60.72-47.65-67.09-60.67-140-11.98-67.09-15.93-84.58%2010.67-140%22%2F%3E%3Cpath%20d%3D%22M904.17%20280c0-14.19%2038.91-22.2%2075.83-22.2%2023.19%200%2044.39%208.61%2044.39%2022.2%200%2015.71-20.01%2036.4-44.39%2036.4-35.73%200-75.83-21.29-75.83-36.4%22%2F%3E%3Cpath%20d%3D%22M0%20389.57c35.62%200%2093.33%205.91%2093.33%2030.43%200%2030.7-65.06%2080-93.33%2080-18.4%200%200-40%200-80%200-15.22-11.04-30.43%200-30.43%22%2F%3E%3Cpath%20d%3D%22M490%20420c0-20.68%2038.38-36.98%2070-36.98%2019.71%200%2032.67%2017.38%2032.67%2036.98%200%2023.39-11.72%2049-32.67%2049-30.39%200-70-26.69-70-49%22%2F%3E%3Cpath%20d%3D%22M1103.33%20420c0-12.74%208.4-21.21%2016.67-21.21%208.2%200%2016.28%208.56%2016.28%2021.21%200%2047.95-8.05%20100-16.28%20100-8.24%200-16.67-52.13-16.67-100%22%2F%3E%3Cpath%20d%3D%22M798.52%20560c0-31.55%206.22-85.27%2041.48-89.6%2055.48-6.81%2067.46%2041.21%20140%2067.33%2051.9%2018.68%20108.89%2016.65%20108.89%2022.27%200%205.51-54.44%200-108.89%200H840c-20.74%200-41.48%2013.25-41.48%200%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3Cmask%20id%3D%22SvgjsMask1037%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h1440v560H0Z%22%2F%3E%3C%2Fmask%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";


// TODO: revisit against the documented pattern — https://lit.dev/docs/components/styles/#sharing-styles
var $11b3930711517813$exports = {};
$11b3930711517813$exports = "/*! modern-normalize v3.0.1 | MIT License | https://github.com/sindresorhus/modern-normalize */\n*,:before,:after{box-sizing:border-box}html{-webkit-text-size-adjust:100%;tab-size:4;font-family:system-ui,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;line-height:1.15}body{margin:0}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{border-color:currentColor}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:100%;line-height:1.15}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}legend{padding:0}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}";


var $7083847913ffc922$exports = {};
$7083847913ffc922$exports = "@font-face{font-family:Inconsolata Variable;font-style:normal;font-display:swap;font-weight:200 900;font-stretch:50% 200%;src:url(inconsolata-vietnamese-wdth-normal.78d15d10.woff2)format(\"woff2-variations\");unicode-range:U+102-103,U+110-111,U+128-129,U+168-169,U+1A0-1A1,U+1AF-1B0,U+300-301,U+303-304,U+308-309,U+323,U+329,U+1EA0-1EF9,U+20AB}@font-face{font-family:Inconsolata Variable;font-style:normal;font-display:swap;font-weight:200 900;font-stretch:50% 200%;src:url(inconsolata-latin-ext-wdth-normal.b8b39526.woff2)format(\"woff2-variations\");unicode-range:U+100-2BA,U+2BD-2C5,U+2C7-2CC,U+2CE-2D7,U+2DD-2FF,U+304,U+308,U+329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Inconsolata Variable;font-style:normal;font-display:swap;font-weight:200 900;font-stretch:50% 200%;src:url(inconsolata-latin-wdth-normal.60e27799.woff2)format(\"woff2-variations\");unicode-range:U+??,U+131,U+152-153,U+2BB-2BC,U+2C6,U+2DA,U+2DC,U+304,U+308,U+329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Indie Flower;font-style:normal;font-display:swap;font-weight:400;src:url(indie-flower-latin-ext-400-normal.17451c8c.woff2)format(\"woff2\"),url(indie-flower-latin-ext-400-normal.74bdc07c.woff)format(\"woff\");unicode-range:U+100-2BA,U+2BD-2C5,U+2C7-2CC,U+2CE-2D7,U+2DD-2FF,U+304,U+308,U+329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Indie Flower;font-style:normal;font-display:swap;font-weight:400;src:url(indie-flower-latin-400-normal.2d561dc5.woff2)format(\"woff2\"),url(indie-flower-latin-400-normal.29b89e62.woff)format(\"woff\");unicode-range:U+??,U+131,U+152-153,U+2BB-2BC,U+2C6,U+2DA,U+2DC,U+304,U+308,U+329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}*,:before,:after{box-sizing:border-box;margin:0;padding:0;line-height:calc(1em + .5rem)}:root{--color-bg:#f6f4e8;--color-form-bg:#e5eee4;--color-input-bg:#f8fafc;--color-input-dark:#cc6d00;--color-input-font-primary:black;--color-input-light:papayawhip;--color-input-primary:#ffa033;--color-link-active:darkblue;--color-primary:#2b5876;--color-toast-bg:#333;--color-toast-icon-bg:#111;--color-white:white;--font-body:\"Inconsolata Variable\", monospace;--font-heading:serif;--font-logo:\"Indie Flower\", cursive;--shadow-input:#00000059 0px 5px 15px;--filter-icon-active:brightness(0) saturate(100%) invert(82%) sepia(47%) saturate(3925%) hue-rotate(332deg) brightness(102%) contrast(107%);--filter-icon-white:brightness(0) saturate(100%) invert(100%) sepia(3%) saturate(7499%) hue-rotate(141deg) brightness(117%) contrast(101%)}body{background-color:var(--color-bg);color:var(--color-input-font-primary);font-family:var(--font-body);background-position:bottom;background-repeat:no-repeat;flex-direction:column;min-height:100dvh;display:flex}h1,h2,h3,h4,h5,h6{font-weight:400}a{color:inherit;text-decoration:none}input,button,progress{appearance:none;background:0 0;border:none;outline:none}[hidden]{display:none!important}input[type=checkbox]{background-color:var(--color-input-light);border:2px solid var(--color-input-primary);cursor:pointer;border-radius:4px;width:20px;height:20px;transition:all .3s;position:relative}input[type=checkbox]:checked{background-color:var(--color-input-primary)}input[type=checkbox]:checked:after{color:var(--color-white);content:\"✔\";font-size:20px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}button{background-color:var(--color-input-primary);box-shadow:var(--shadow-input);color:var(--color-input-font-primary);cursor:pointer;font-family:var(--font-body);border-radius:20px;padding:.5em 1.5em;font-size:1.5rem;transition:all .3s}button:hover{background-color:var(--color-input-dark);transform:translateY(-2px)}button:active{background-color:var(--color-input-light);transform:translateY(0)}a:focus-visible,button:focus-visible,input:focus-visible{outline:3px solid var(--color-link-active);outline-offset:3px}input[type=text]:focus-visible{outline:none}input[type=text].tab-pressed:focus-visible{outline:3px solid var(--color-link-active);outline-offset:-3px}.visually-hidden{clip:rect(1px, 1px, 1px, 1px)!important;white-space:nowrap!important;border-width:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}.vertically-centered-container{flex-direction:column;flex-grow:1;justify-content:center;align-items:center;display:flex}.icon{vertical-align:-.125em;background-position:50%;background-repeat:no-repeat;background-size:contain;width:24px;height:24px;display:inline-block}.icon--hoverable:hover .icon{filter:var(--filter-icon-active)}.icon--white{filter:var(--filter-icon-white)}.icon--user{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20640%20640%22%3E%3Cpath%20d%3D%22M320%20312c66.3%200%20120-53.7%20120-120S386.3%2072%20320%2072s-120%2053.7-120%20120%2053.7%20120%20120%20120m-29.7%2056C191.8%20368%20112%20447.8%20112%20546.3c0%2016.4%2013.3%2029.7%2029.7%2029.7h356.6c16.4%200%2029.7-13.3%2029.7-29.7%200-98.5-79.8-178.3-178.3-178.3Z%22%2F%3E%3C%2Fsvg%3E)}.icon--info-circle{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20640%20640%22%3E%3C%21--%21Font%20Awesome%20Free%20v7.3.0%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202026%20Fonticons%2C%20Inc.--%3E%3Cpath%20d%3D%22M320%20576c141.4%200%20256-114.6%20256-256S461.4%2064%20320%2064%2064%20178.6%2064%20320s114.6%20256%20256%20256m-32-352c0-17.7%2014.3-32%2032-32s32%2014.3%2032%2032-14.3%2032-32%2032-32-14.3-32-32m-8%2064h48c13.3%200%2024%2010.7%2024%2024v88h8c13.3%200%2024%2010.7%2024%2024s-10.7%2024-24%2024h-80c-13.3%200-24-10.7-24-24s10.7-24%2024-24h24v-64h-24c-13.3%200-24-10.7-24-24s10.7-24%2024-24%22%2F%3E%3C%2Fsvg%3E)}.icon--envelope{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20640%20640%22%3E%3C%21--%21Font%20Awesome%20Free%20v7.3.0%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202026%20Fonticons%2C%20Inc.--%3E%3Cpath%20d%3D%22M112%20128c-26.5%200-48%2021.5-48%2048%200%2015.1%207.1%2029.3%2019.2%2038.4l208%20156a48%2048%200%200%200%2057.6%200l208-156c12.1-9.1%2019.2-23.3%2019.2-38.4%200-26.5-21.5-48-48-48ZM64%20260v188c0%2035.3%2028.7%2064%2064%2064h384c35.3%200%2064-28.7%2064-64V260L377.6%20408.8c-34.1%2025.6-81.1%2025.6-115.2%200Z%22%2F%3E%3C%2Fsvg%3E)}.icon--plus-square{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20640%20640%22%3E%3C%21--%21Font%20Awesome%20Free%20v7.2.0%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202026%20Fonticons%2C%20Inc.--%3E%3Cpath%20d%3D%22M160%20144c-8.8%200-16%207.2-16%2016v320c0%208.8%207.2%2016%2016%2016h320c8.8%200%2016-7.2%2016-16V160c0-8.8-7.2-16-16-16Zm-64%2016c0-35.3%2028.7-64%2064-64h320c35.3%200%2064%2028.7%2064%2064v320c0%2035.3-28.7%2064-64%2064H160c-35.3%200-64-28.7-64-64Zm200%20248v-64h-64c-13.3%200-24-10.7-24-24s10.7-24%2024-24h64v-64c0-13.3%2010.7-24%2024-24s24%2010.7%2024%2024v64h64c13.3%200%2024%2010.7%2024%2024s-10.7%2024-24%2024h-64v64c0%2013.3-10.7%2024-24%2024s-24-10.7-24-24%22%2F%3E%3C%2Fsvg%3E)}.icon--paper-plane{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3C%21--%21Font%20Awesome%20Free%20v6.7.2%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202026%20Fonticons%2C%20Inc.--%3E%3Cpath%20d%3D%22M498.1%205.6c10.1%207%2015.4%2019.1%2013.5%2031.2l-64%20416c-1.5%209.7-7.4%2018.2-16%2023s-18.9%205.4-28%201.6L284%20427.7l-68.5%2074.1c-8.9%209.7-22.9%2012.9-35.2%208.1S160%20493.2%20160%20480v-83.6c0-4%201.5-7.8%204.2-10.8l167.6-182.8c5.8-6.3%205.6-16-.4-22s-15.7-6.4-22-.7L106%20360.8l-88.3-44.2C7.1%20311.3.3%20300.7%200%20288.9s5.9-22.8%2016.1-28.7l448-256c10.7-6.1%2023.9-5.5%2034%201.4%22%2F%3E%3C%2Fsvg%3E)}.icon--copy{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20640%20640%22%3E%3C%21--%21Font%20Awesome%20Free%20v7.2.0%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202026%20Fonticons%2C%20Inc.--%3E%3Cpath%20d%3D%22M480%20400H288c-8.8%200-16-7.2-16-16V128c0-8.8%207.2-16%2016-16h133.5c4.2%200%208.3%201.7%2011.3%204.7l58.5%2058.5c3%203%204.7%207.1%204.7%2011.3V384c0%208.8-7.2%2016-16%2016m-192%2048h192c35.3%200%2064-28.7%2064-64V186.5c0-17-6.7-33.3-18.7-45.3l-58.6-58.5c-12-12-28.2-18.7-45.2-18.7H288c-35.3%200-64%2028.7-64%2064v256c0%2035.3%2028.7%2064%2064%2064M160%20192c-35.3%200-64%2028.7-64%2064v256c0%2035.3%2028.7%2064%2064%2064h192c35.3%200%2064-28.7%2064-64v-16h-48v16c0%208.8-7.2%2016-16%2016H160c-8.8%200-16-7.2-16-16V256c0-8.8%207.2-16%2016-16h16v-48Z%22%2F%3E%3C%2Fsvg%3E)}.icon--rotate-right{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20640%20640%22%3E%3C%21--%21Font%20Awesome%20Free%20v7.2.0%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202026%20Fonticons%2C%20Inc.--%3E%3Cpath%20d%3D%22m500.7%20138.7%2011.3%2010.7V96c0-17.7%2014.3-32%2032-32s32%2014.3%2032%2032v128c0%2017.7-14.3%2032-32%2032H416c-17.7%200-32-14.3-32-32s14.3-32%2032-32h47.9l-7.6-7.2-.6-.6c-75-75-196.5-75-271.5%200s-75%20196.5%200%20271.5%20196.5%2075%20271.5%200q12.3-12.3%2021.9-26.1c10.1-14.5%2030.1-18%2044.6-7.9s18%2030.1%207.9%2044.6c-8.5%2012.2-18.2%2023.8-29.1%2034.7-100%20100-262.1%20100-362%200s-100-262%200-362c99.9-99.9%20261.7-100%20361.7-.3%22%2F%3E%3C%2Fsvg%3E)}.icon--clipboard-check{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20640%20640%22%3E%3C%21--%21Font%20Awesome%20Free%20v7.3.0%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202026%20Fonticons%2C%20Inc.--%3E%3Cpath%20d%3D%22M384%2064c23.7%200%2044.4%2012.9%2055.4%2032h8.6c35.3%200%2064%2028.7%2064%2064v352c0%2035.3-28.7%2064-64%2064H192c-35.3%200-64-28.7-64-64V160c0-35.3%2028.7-64%2064-64h8.6c11-19.1%2031.7-32%2055.4-32Zm26.9%20212.6c-10.7-7.8-25.7-5.4-33.5%205.3l-85.6%20117.7-26.5-27.4c-9.2-9.5-24.4-9.8-33.9-.6s-9.8%2024.4-.6%2033.9l46.4%2048c4.9%205.1%2011.8%207.8%2018.9%207.3s13.6-4.1%2017.8-9.8l102.3-140.9c7.8-10.7%205.4-25.7-5.3-33.5M264%20128c-13.3%200-24%2010.7-24%2024s10.7%2024%2024%2024h112c13.3%200%2024-10.7%2024-24s-10.7-24-24-24Z%22%2F%3E%3C%2Fsvg%3E)}@media screen and (width>=320px){body{background-image:url(background_clouds_w400.68162d94.svg)}}@media screen and (width>=384px){body{background-image:url(background_clouds_w500.c94ebf46.svg)}}@media screen and (width>=448px){body{background-image:url(background_clouds_w650.b9c30fba.svg)}}@media screen and (width>=576px){body{background-image:url(background_clouds_w800.c9effdfc.svg)}}@media screen and (width>=768px){body{background-image:url(background_clouds_w1024.b57cd5fc.svg)}}@media screen and (width>=1024px){body{background-image:url(background_clouds_w4096.bc3f262a.svg)}}@media screen and (width>=3841px){body{background-image:url(background_clouds_w8192.34019fa8.svg)}}@keyframes fadeIn{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}@media (prefers-reduced-motion:reduce){input[type=checkbox],button{transition:none}button:hover{transform:none}}";


var $1cf54a9d665ed0de$exports = {};
$1cf54a9d665ed0de$exports = ".mi-auto{margin-inline:auto}.mt-1rem{margin-top:1rem}.mb-1rem{margin-bottom:1rem}.ml-1rem{margin-left:1rem}.container{width:100%;margin-inline:auto;padding-inline:.5rem}.container-width{width:100%;margin-inline:auto}.container-padding{padding-inline:.5rem}@media screen and (width>=320px){.container,.container-width{max-width:304px}}@media screen and (width>=384px){.container,.container-width{max-width:364.8px}}@media screen and (width>=448px){.container,.container-width{max-width:425.6px}}@media screen and (width>=576px){.container,.container-width{max-width:547.2px}}@media screen and (width>=768px){.container,.container-width{max-width:729.6px}}@media screen and (width>=1024px){.container,.container-width{max-width:972.8px}}";


const $b4a8fe39896acb26$export$1b13cf45be3444ea = new CSSStyleSheet();
$b4a8fe39896acb26$export$1b13cf45be3444ea.replaceSync((0, (/*@__PURE__*/$parcel$interopDefault($11b3930711517813$exports))));
const $b4a8fe39896acb26$export$88a3a316594f4b96 = new CSSStyleSheet();
$b4a8fe39896acb26$export$88a3a316594f4b96.replaceSync((0, (/*@__PURE__*/$parcel$interopDefault($7083847913ffc922$exports))));
const $b4a8fe39896acb26$export$ddc714640f86df61 = new CSSStyleSheet();
$b4a8fe39896acb26$export$ddc714640f86df61.replaceSync((0, (/*@__PURE__*/$parcel$interopDefault($1cf54a9d665ed0de$exports))));


// macOS provide filenames in decomposed Unicode (NFD), which can render
// Turkish, Spanish, Korean combining marks with visual offsets in some fonts. Normalize to NFC.
const $e77a20d3ef2523af$var$normalizeFileName = (name)=>typeof name === 'string' ? name.normalize('NFC') : '';
class $e77a20d3ef2523af$export$2e2bcd8739ae039 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static styles = [
        (0, $b4a8fe39896acb26$export$1b13cf45be3444ea),
        (0, $b4a8fe39896acb26$export$88a3a316594f4b96),
        (0, $b4a8fe39896acb26$export$ddc714640f86df61),
        (0, $3233927aa82734f9$export$dbf350e5966cf602)`
        :host {
            display: block;
        }

        /* Without this, setting the \`hidden\` attribute/property has no visible effect:
           the UA stylesheet's [hidden] { display: none; } is a lower-priority origin
           than this component's own :host { display: block; } rule above, so origin
           order (author beats user-agent, regardless of specificity) lets :host win
           and the element stays visible even while hidden. */
        :host([hidden]) {
            display: none;
        }

        .upload-form {
            animation: fadeIn 0.5s ease-out;
            background-color: var(--color-form-bg);
            /* background-image is set via styleMap() in render(), not here */
            border-radius: 20px;
            box-shadow: var(--shadow-input);
            padding-block: 30px;
        }

        .upload-form__file-select {
            align-items: center;
            background-color: var(--color-input-bg);
            border-radius: 10px;
            box-shadow: var(--shadow-input);
            display: flex;
            justify-content: space-between;
            overflow: hidden;
            padding-inline: 0.5rem;
        }

        .upload-form__text-input {
            color: var(--color-input-font-primary);
            cursor: pointer;
            flex-grow: 1;
            overflow: hidden;
            padding: 1rem;
            text-overflow: ellipsis;
            text-wrap: nowrap;
        }

        .upload-form__add-button {
            align-items: center;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            font-size: 1.5rem;
            height: 35px;
            justify-content: center;
            width: 35px;
        }

        .upload-form__add-button:hover {
            color: var(--color-input-primary);
            fill: currentColor;
        }

        .upload-form__accept-terms {
            align-items: center;
            display: flex;
            font-family: var(--font-body);
            justify-content: center;
        }

        .upload-form__accept-terms--not-accepted {
            animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
        }

        .upload-form__accept-terms input[type="checkbox"] {
            margin-right: 0.5rem;
        }

        .upload-form__accept-terms label {
            cursor: pointer;
            user-select: none;
        }

        .upload-form__submit {
            display: block;
            width: 10em;
        }

        /* md */
        @media screen and (min-width: 448px) {
            .upload-form__text-input, .upload-form__accept-terms {
                font-size: 1rem;
            }
        }
        /* xl */
        @media screen and (min-width: 576px) {
            .upload-form__text-input, .upload-form__accept-terms {
                font-size: 1.25rem;
            }
        }

        /* 3xl */
        @media screen and (min-width: 768px) {
            .upload-form__text-input, .upload-form__accept-terms {
                font-size: 1.5rem;
            }
        }

        /* 5xl */
        @media screen and (min-width: 1024px) {
            .upload-form__file-select {
                max-width: 768px;
            }
        }

        @media (prefers-reduced-motion: reduce) {
            .upload-form {
                animation: none;
            }

            .upload-form__accept-terms--not-accepted {
                animation: reduced-motion-animation 2s linear;
            }
        }

        @keyframes shake-horizontal {
            0%,
            100% {
                transform: translateX(0);
            }
            10%,
            30%,
            50%,
            70% {
                transform: translateX(-10px);
            }
            20%,
            40%,
            60% {
                transform: translateX(10px);
            }
            80% {
                transform: translateX(8px);
            }
            90% {
                transform: translateX(-8px);
            }
        }

        @keyframes reduced-motion-animation {
            0% {
                opacity: 0;
                text-decoration: overline;
                text-decoration-thickness: 5px;
            }

            50% {
                text-decoration-thickness: 1px;
            }

            100% {
                opacity: 1;
                text-decoration: none;
            }
        }
    `
    ];
    #selectedFile = null;
    // Bound as a class field (not a #-prefixed prototype method) so the same
    // reference can be passed to both addEventListener and removeEventListener —
    // same convention as ProgressDivElement's #handleReducedMotionChange.
    // Ported from static/script/index.js's `window.addEventListener('pageshow', ...)`:
    // browsers may restore form controls from bfcache on back/forward navigation,
    // so this form is reset on every pageshow, not just on first connect.
    #handlePageShow = ()=>{
        this.reset();
    };
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('pageshow', this.#handlePageShow);
    }
    disconnectedCallback() {
        window.removeEventListener('pageshow', this.#handlePageShow);
        super.disconnectedCallback();
    }
    // Read-only from outside: no setter is defined, so `formUploadEl.selectedFile = x`
    // throws (class bodies are strict mode) instead of silently doing nothing — the
    // only writer of #selectedFile is #handleFileChange, below.
    get selectedFile() {
        return this.#selectedFile;
    }
    // Public: called by an ancestor (e.g. <upload-container> on "Upload Another")
    // to clear the current selection/acceptance state before re-showing this form.
    // The native file input isn't reactive, so its value must be cleared here too —
    // otherwise the browser won't fire another change event for the same file path.
    reset() {
        this.#selectedFile = null;
        this.renderRoot.getElementById('hidden-file-input').value = '';
        this.renderRoot.getElementById('selected-file-name').value = '';
        this.renderRoot.getElementById('checkbox-accept').checked = false;
        // Strips a leftover shake-trigger class from an earlier rejected click in this
        // session. Without this, un-hiding the form (display: none → block) restarts
        // shake-horizontal from scratch if the class is still present, even though no
        // invalid click just happened — see _plans/4.2-lit_form_upload_component.md Step 16.
        this.renderRoot.querySelector('.upload-form__accept-terms')?.classList.remove('upload-form__accept-terms--not-accepted');
    }
    // Public: called by an ancestor (e.g. <upload-container> on "Upload Another")
    // to move focus onto the file-select control once this form is shown again —
    // mirrors static/script/index.js's uploadAnotherButton handler calling
    // selectedFileName.focus() right after re-showing #form-upload.
    focusFileSelect() {
        this.renderRoot.getElementById('selected-file-name').focus();
    }
    // Opens the native file picker — bound to both the "+" button and the readonly
    // text input, mirroring static/script/index.js's fileSelectButton/selectedFileName handlers.
    #openFilePicker() {
        this.renderRoot.getElementById('hidden-file-input').click();
    }
    #handleFileChange(e) {
        const selectedFile = e.target.files && e.target.files[0];
        this.#selectedFile = selectedFile ?? null;
        this.renderRoot.getElementById('selected-file-name').value = selectedFile ? $e77a20d3ef2523af$var$normalizeFileName(selectedFile.name) : '';
    }
    // Native :focus-visible can't tell Tab-focus apart from click/programmatic focus
    // for text inputs (browsers intentionally match it on click for those too). Mark
    // the input Tab lands on so CSS can show the outline only for that case.
    // Tab's keydown fires on the element about to lose focus; by keyup, focus has
    // already moved, so e.target here is the newly-focused element.
    #handleTextInputTabKeyUp(e) {
        if (e.key === 'Tab') e.target.classList.add('tab-pressed');
    }
    // Using blur (not focusout) clears the marker correctly when focus round-trips
    // through a native OS dialog (e.g. the file picker) and returns to the same input.
    #handleTextInputBlur(e) {
        e.target.classList.remove('tab-pressed');
    }
    // input[type="text"] and input[type="checkbox"] sit inside a <form> with no
    // type="submit" button. Per the HTML implicit-submission rule, a form with no submit
    // button still submits on Enter if it has exactly one single-line text field — which
    // is the shape of this form — reloading the page. Space has its own default
    // (checkbox toggle / page scroll). Prevent both defaults and instead fire the same
    // `click` each element already responds to, so keyboard activation matches mouse
    // activation exactly. `e.repeat` guards against auto-repeat firing click on every
    // repeated keydown while the key is held, matching native single-activation-per-press
    // button/checkbox behavior.
    #handleKeyboardActivate(e) {
        if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
            e.preventDefault();
            e.target.click();
        }
    }
    // Mirrors static/script/index.js's submitButton handler: clicking Upload without
    // the terms checkbox checked replays the shake-horizontal animation instead of submitting.
    // When accepted, this component doesn't hide itself — it announces the click and lets
    // an ancestor (e.g. <upload-container>) own cross-component visibility/coordination.
    #handleSubmitClick() {
        const acceptTermsCheckbox = this.renderRoot.getElementById('checkbox-accept');
        if (acceptTermsCheckbox && acceptTermsCheckbox.checked) {
            this.dispatchEvent(new CustomEvent('upload-button-clicked', {
                bubbles: true,
                composed: true
            }));
            return;
        }
        const acceptTermsContainer = this.renderRoot.querySelector('.upload-form__accept-terms');
        if (acceptTermsContainer) {
            // Re-adding the class retriggers the CSS animation on every invalid click.
            acceptTermsContainer.classList.remove('upload-form__accept-terms--not-accepted');
            // Force the browser to apply class removal now, so adding it again restarts the animation.
            // `void <expression>` runs the expression and discards its result (returns undefined).
            // Here we only need the side effect of reading layout (`offsetWidth`) to trigger reflow.
            acceptTermsContainer.offsetWidth;
            acceptTermsContainer.classList.add('upload-form__accept-terms--not-accepted');
        }
    }
    render() {
        // background-image for .upload-form, kept out of static styles css since Parcel can't resolve data-url: inside it
        // .container-padding applied here (inside the shadow template), not on the host in index.html —
        // padding is this component's own internal layout decision, not the parent's to set. See utils.css.
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <form id="form-upload" class="container-padding upload-form" autocomplete="off" style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)({
            backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($1a8b8fcaadcb0100$exports)))})`
        })}>
                <div class="upload-form__file-select icon--hoverable mi-auto">
                    <input id="hidden-file-input" type="file" hidden @change=${this.#handleFileChange}>
                    <label class="visually-hidden" for="selected-file-name">Select the file (Max. 5GB): </label>
                    <input id="selected-file-name" type="text" class="upload-form__text-input" placeholder="(Max 5GB) Select the file" readonly @click=${this.#openFilePicker} @keyup=${this.#handleTextInputTabKeyUp} @blur=${this.#handleTextInputBlur} @keydown=${this.#handleKeyboardActivate}/>
                    <i id="button-add" class="upload-form__add-button icon icon--plus-square" aria-hidden="true" @click=${this.#openFilePicker}></i>
                </div>
                <div class="upload-form__accept-terms mt-1rem">
                    <input id="checkbox-accept" type="checkbox" @keydown=${this.#handleKeyboardActivate}/>
                    <label for="checkbox-accept">I accept the terms & conditions</label>
                </div>
                <button class="upload-form__submit mt-1rem mi-auto" type="button" @click=${this.#handleSubmitClick}>
                    Upload
                    <i class="icon icon--paper-plane" aria-hidden="true"></i>
                </button>
            </form>
        `;
    }
}
customElements.define('tempup-form-upload', $e77a20d3ef2523af$export$2e2bcd8739ae039);




var $10e28a38ac1e2533$exports = {};
$10e28a38ac1e2533$exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%221440%22%20height%3D%22560%22%20preserveAspectRatio%3D%22none%22%20viewBox%3D%220%200%201440%20560%22%3E%3Cg%20fill%3D%22none%22%20mask%3D%22url%28%23SvgjsMask1036%29%22%3E%3Cpath%20fill%3D%22%23afe1f1%22%20d%3D%22M0%20279c96-35.2%20288-157.2%20480-176s288%2086.4%20480%2082%20384-83.2%20480-104v479H0Z%22%2F%3E%3Cpath%20fill%3D%22%23b6d1ef%22%20d%3D%22M0%20381c144%2013%20432%2084.6%20720%2065s576-130.4%20720-163v277H0Z%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3Cmask%20id%3D%22SvgjsMask1036%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h1440v560H0Z%22%2F%3E%3C%2Fmask%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";



// macOS provide filenames in decomposed Unicode (NFD), which can render
// Turkish, Spanish, Korean combining marks with visual offsets in some fonts. Normalize to NFC.
const $1673ba8b99dc8859$var$normalizeFileName = (name)=>typeof name === 'string' ? name.normalize('NFC') : '';


class $1673ba8b99dc8859$export$2e2bcd8739ae039 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static properties = {
        fileName: {
            attribute: false
        },
        progressValue: {
            attribute: false
        }
    };
    static styles = [
        (0, $b4a8fe39896acb26$export$1b13cf45be3444ea),
        (0, $b4a8fe39896acb26$export$88a3a316594f4b96),
        (0, $b4a8fe39896acb26$export$ddc714640f86df61),
        (0, $3233927aa82734f9$export$dbf350e5966cf602)`
        :host {
            display: block;
        }

        /* Without this, setting the \`hidden\` attribute/property has no visible effect:
           the UA stylesheet's [hidden] { display: none; } is a lower-priority origin
           than this component's own :host { display: block; } rule above, so origin
           order (author beats user-agent, regardless of specificity) lets :host win
           and the element stays visible even while hidden. */
        :host([hidden]) {
            display: none;
        }

        .progress-div {
            animation: fadeIn 0.5s ease-out;
            background-color: var(--color-form-bg);
            /* background-image is set via styleMap() in render(), not here */
            background-position: bottom;
            border-radius: 20px;
            box-shadow: var(--shadow-input);
            font-family: var(--font-body);
            padding-block-end: 30px;
            padding-block-start: 150px;
            position: relative;
        }

        .progress-div__animation {
            height: 300px;
            left: 35%;
            position: absolute;
            top: -35%;
            width: 300px;
        }

        .progress-div__file-name {
            overflow: hidden;
            text-align: center;
            text-overflow: ellipsis;
            text-wrap: nowrap;
        }

        .progress-div__progress-bar {
            background-color: var(--color-input-bg);
            border-radius: 10px;
            box-shadow: var(--shadow-input); /* for Firefox */
            color: var(--color-input-primary);
            display: block;
            height: 20px;
            overflow: hidden;
            width: 100%;
        }

        .progress-div__progress-bar::-webkit-progress-bar {
            background-color: var(--color-input-bg);
            border-radius: 10px;
            box-shadow: var(--shadow-input); /* for Chrome */
        }

        .progress-div__progress-bar::-webkit-progress-value {
            background-color: var(--color-input-primary);
            border-radius: 10px;
        }

        .progress-div__progress-bar::-moz-progress-bar {
            background-color: var(--color-input-primary);
            border-radius: 10px;
        }

        /* xs */
        @media screen and (min-width: 320px) {
            .progress-div__animation {
                left: 0%;
            }
        }

        /* sm */
        @media screen and (min-width: 384px) {
            .progress-div__animation {
                left: 10%;
            }
        }

        /* md */
        @media screen and (min-width: 448px) {
            .progress-div__animation {
                left: 15%;
            }

            .progress-div__file-name {
                font-size: 1rem;
            }
        }

        /* xl */
        @media screen and (min-width: 576px) {
            .progress-div__animation {
                left: 25%;
            }

            .progress-div__file-name {
                font-size: 1.25rem;
            }
        }

        /* 3xl */
        @media screen and (min-width: 768px) {
            .progress-div__animation {
                left: 30%;
            }

            .progress-div__file-name {
                font-size: 1.5rem;
            }
        }

        /* 5xl */
        @media screen and (min-width: 1024px) {
            .progress-div__animation {
                left: 35%;
            }

            .progress-div__progress-bar {
                max-width: 768px;
            }
        }

        @media (prefers-reduced-motion: reduce) {
            .progress-div {
                animation: none;
            }
        }
    `
    ];
    constructor(){
        super();
        this.fileName = 'File name here';
        this.progressValue = 0;
    }
    // Overrides the native reflected `hidden` accessor (inherited from HTMLElement.prototype,
    // not declared via static properties) so that becoming visible always loads/plays the
    // animation — the component owns this pairing itself, rather than requiring every caller
    // that toggles `.hidden` to remember to also call `loadAnimation()`.
    get hidden() {
        return super.hidden;
    }
    set hidden(value) {
        super.hidden = value;
        if (!value) this.loadAnimation();
    }
    #currentAnimation = null;
    #reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    #handleReducedMotionChange = (event)=>{
        if (!this.#currentAnimation) return;
        if (event.matches) this.#currentAnimation.pause();
        else this.#currentAnimation.play();
    };
    connectedCallback() {
        super.connectedCallback();
        this.#reducedMotionQuery.addEventListener('change', this.#handleReducedMotionChange);
    }
    disconnectedCallback() {
        this.#reducedMotionQuery.removeEventListener('change', this.#handleReducedMotionChange);
        this.#currentAnimation?.destroy();
        super.disconnectedCallback();
    }
    // Loads (or reloads) the Lottie plane animation into .progress-div__animation. Mirrors
    // static/script/index.js's progressAnimationEl handling — must be called only once this
    // component is visible and its layout has settled, since Lottie measures the container's
    // size at loadAnimation() time. Called automatically from the `hidden` setter above.
    async loadAnimation() {
        const animationContainer = this.renderRoot.querySelector('.progress-div__animation');
        if (!animationContainer) return;
        const [lottieModule, animationModule] = await Promise.all([
            (parcelRequire("egFgR")),
            (parcelRequire("fcnwe"))
        ]);
        // Parcel dynamic imports don't apply ESM interop to JSON/CommonJS assets:
        // the JSON module resolves to the parsed object itself, with no `.default`.
        const lottie = lottieModule.default ?? lottieModule;
        const animationData = animationModule.default ?? animationModule;
        this.#currentAnimation?.destroy();
        this.#currentAnimation = lottie.loadAnimation({
            container: animationContainer,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            animationData: animationData
        });
        if (this.#reducedMotionQuery.matches) this.#currentAnimation.pause();
        else this.#currentAnimation.play();
    }
    // Public: called by an ancestor (e.g. <upload-container>) once this component
    // is shown, to move focus onto the progress bar for screen readers — mirrors
    // static/script/index.js's submitButton handler calling progressBar.focus()
    // right after revealing #div-progress.
    focusProgressBar() {
        this.renderRoot.getElementById('progress-upload').focus();
    }
    render() {
        // background-image for .progress-div, kept out of static styles css since Parcel can't resolve data-url: inside it
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div id="div-progress" class="container-padding progress-div" role="status" aria-live="polite" style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)({
            backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($10e28a38ac1e2533$exports)))})`
        })}>
                <div class="progress-div__animation mi-auto" aria-hidden="true"></div>
                <p class="progress-div__file-name">${$1673ba8b99dc8859$var$normalizeFileName(this.fileName)}</p>
                <label class="visually-hidden" for="progress-upload">Upload progress: </label>
                <progress id="progress-upload" class="progress-div__progress-bar mt-1rem mi-auto" value="${this.progressValue}" max="100" tabindex="-1"></progress>
            </div>
        `;
    }
}
customElements.define('tempup-progress-div', $1673ba8b99dc8859$export$2e2bcd8739ae039);




var $47413cbc80342208$exports = {};
$47413cbc80342208$exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%221440%22%20height%3D%22560%22%20preserveAspectRatio%3D%22none%22%20viewBox%3D%220%200%201440%20560%22%3E%3Cg%20fill%3D%22none%22%20mask%3D%22url%28%23SvgjsMask1253%29%22%3E%3Cpath%20fill%3D%22%238f97ff%22%20d%3D%22M0%20154C96%20128.6%20288%2033.8%20480%2027s288%2090%20480%2093%20384-62.4%20480-78v518H0Z%22%2F%3E%3Cpath%20fill%3D%22%23aecff1%22%20d%3D%22M0%20345c144-14%20432-66.4%20720-70s576%2041.6%20720%2052v233H0Z%22%2F%3E%3Cpath%20fill%3D%22%23bbf5e5%22%20d%3D%22M0%20517c96-20.2%20288-97.6%20480-101s288%2092.6%20480%2084%20384-101.6%20480-127v187H0Z%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3Cmask%20id%3D%22SvgjsMask1253%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h1440v560H0Z%22%2F%3E%3C%2Fmask%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";


var $accae00d3388bae7$exports = {};
$accae00d3388bae7$exports = import.meta.resolve("gkR5z");



// The displayed link (this.downloadLink) is intentionally scheme-less/www-less (see
// upload-container.js's getDisplayOrigin, which produces it), but a copied link should
// be a fully-qualified, directly-pasteable URL — re-add the page's own scheme (http/https)
// and a `www.` prefix. Duplicated from static/script/index.js, same precedent as
// normalizeFileName in form-upload.js/progress-div.js (components don't import from
// the page-level script).
const $8f82d61bec433391$var$toClipboardLink = (displayLink)=>`${window.location.protocol}//www.${displayLink}`;
class $8f82d61bec433391$export$2e2bcd8739ae039 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static properties = {
        downloadLink: {}
    };
    static styles = [
        (0, $b4a8fe39896acb26$export$1b13cf45be3444ea),
        (0, $b4a8fe39896acb26$export$88a3a316594f4b96),
        (0, $b4a8fe39896acb26$export$ddc714640f86df61),
        (0, $3233927aa82734f9$export$dbf350e5966cf602)`
        :host {
            display: block;
        }

        /* Without this, setting the \`hidden\` attribute/property has no visible effect:
           the UA stylesheet's [hidden] { display: none; } is a lower-priority origin
           than this component's own :host { display: block; } rule above, so origin
           order (author beats user-agent, regardless of specificity) lets :host win
           and the element stays visible even while hidden. */
        :host([hidden]) {
            display: none;
        }

        .upload-complete-form {
            align-items: center;
            animation: fadeIn 0.5s ease-out;
            background-color: var(--color-form-bg);
            /* background-image is set via styleMap() in render(), not here */
            background-position: bottom;
            border-radius: 20px;
            box-shadow: var(--shadow-input);
            display: flex;
        }

        .upload-complete-form__right-side {
            flex-grow: 1;
        }

        .upload-complete-form__copy-area {
            align-items: center;
            background-color: var(--color-input-bg);
            border-radius: 10px;
            box-shadow: var(--shadow-input);
            display: flex;
            justify-content: space-between;
            overflow: hidden;
            padding-inline: 0.5rem;
        }

        .upload-complete-form__text-input {
            color: var(--color-link-active);
            cursor: pointer;
            flex-grow: 1;
            overflow: hidden;
            padding: 1rem;
            text-decoration: underline;
            text-decoration-thickness: 1px;
            text-overflow: ellipsis;
            text-underline-offset: 5px;
            text-wrap: nowrap;
        }

        .upload-complete-form__copy-button {
            align-items: center;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            font-size: 1.5rem;
            height: 35px;
            justify-content: center;
            width: 35px;
            /* transition: all 0.3s */ /* When 'all' is used, during the initial phases of color transition, some pink color shown. FIXME */
        }

        .upload-complete-form__upload-another{
            display: block;
            width: 12em;
        }

        /* also .upload-complete-form__copy-button:hover path
           selector works too
         */
        .upload-complete-form__copy-button:hover {
            color: var(--color-input-primary);
            fill: currentColor;
        }

        /* xs */
        @media screen and (min-width: 320px) {
            .upload-complete-form {
                flex-direction: column;
                padding-block-end: 20px;
            }

            .upload-complete-form__image {
                height: 120px;
                margin-bottom: 1rem;
                width: 120px;
            }

            .upload-complete-form__right-side {
                width: 100%;
            }
        }

        /* md */
        @media screen and (min-width: 448px) {
            .upload-complete-form__image {
                height: 150px;
                margin-bottom: 0;
                width: 150px;
            }

            .upload-complete-form__info {
                font-size: 1rem;
            }

            .upload-complete-form__text-input {
                font-size: 1rem;
            }
        }

        /* xl */
        @media screen and (min-width: 576px) {
            .upload-complete-form__image {
                height: 180px;
                width: 180px;
            }

            .upload-complete-form__info {
                font-size: 1.25rem;
            }

            .upload-complete-form__text-input {
                font-size: 1.25rem;
            }
        }

        /* 3xl */
        @media screen and (min-width: 768px) {
            .upload-complete-form {
                flex-direction: row;
                padding-block-start: 20px;
            }

            .upload-complete-form__info {
                font-size: 1.5rem;
            }

            .upload-complete-form__text-input {
                font-size: 1.5rem;
            }
        }

        /* 5xl */
        @media screen and (min-width: 1024px) {
            .upload-complete-form {
                padding-block-end: 0px;
                padding-block-start: 0px;
            }

            .upload-complete-form__image {
                height: 230px;
                width: 230px;
            }

            .upload-complete-form__copy-area {
                max-width: 576px;
            }
        }

        @media (prefers-reduced-motion: reduce) {
            .upload-complete-form {
                animation: none;
            }
        }
    `
    ];
    // Default assigned in the constructor, not as a class field: a class field would
    // define an own property via [[DefineOwnProperty]] that shadows the reactive
    // accessor Lit generates from `static properties`, silently breaking updates
    // (see _plans/4.3-lit_progress_div_component.md Step 8 for the bug this avoids).
    constructor(){
        super();
        this.downloadLink = 'tempup.io/file/ABCD1234';
    }
    // Native :focus-visible can't tell Tab-focus apart from click/programmatic focus
    // for text inputs (browsers intentionally match it on click for those too). Mark
    // the input Tab lands on so CSS can show the outline only for that case.
    // Tab's keydown fires on the element about to lose focus; by keyup, focus has
    // already moved, so e.target here is the newly-focused element.
    #handleTextInputTabKeyUp(e) {
        if (e.key === 'Tab') e.target.classList.add('tab-pressed');
    }
    // Using blur (not focusout) clears the marker correctly when focus round-trips
    // through a native OS dialog (e.g. the file picker) and returns to the same input.
    #handleTextInputBlur(e) {
        e.target.classList.remove('tab-pressed');
    }
    // input[type="text"] sits inside a <form> with no type="submit" button. Per the HTML
    // implicit-submission rule, a form with no submit button still submits on Enter if it
    // has exactly one single-line text field — which is the shape of this form — reloading
    // the page. Space has its own default (page scroll). Prevent both defaults and instead
    // fire the same `click` this element already responds to, so keyboard activation
    // matches mouse activation exactly. `e.repeat` guards against auto-repeat firing click
    // on every repeated keydown while the key is held, matching native single-activation-
    // per-press button behavior.
    #handleKeyboardActivate(e) {
        if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
            e.preventDefault();
            e.target.click();
        }
    }
    // Mirrors FormUploadElement's #handleSubmitClick (form-upload plan Step 13):
    // this component doesn't hide itself — it announces the click and lets an
    // ancestor (e.g. <upload-container>) own cross-component coordination.
    #handleUploadAnotherClick() {
        this.dispatchEvent(new CustomEvent('upload-another-clicked', {
            bubbles: true,
            composed: true
        }));
    }
    // Public: called by an ancestor (e.g. <upload-container>) once this component
    // is shown, to move focus onto the download-link input — mirrors
    // static/script/index.js's finishUpload calling downloadLinkInput.focus()
    // right after revealing #form-upload-complete.
    focusDownloadLink() {
        this.renderRoot.getElementById('input-download-link').focus();
    }
    // Mirrors static/script/index.js's copyDownloadLink, bound to both #input-download-link
    // and #button-copy (same two listeners the original attaches). TODO: showToast()'s
    // equivalent isn't called here yet — no toast component exists in this migration yet.
    async #copyDownloadLink() {
        if (!this.downloadLink) return;
        // TODO: Remove this
        // It's check for fallback support of the Clipboard API, which is used in modern browsers.
        if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') return;
        await navigator.clipboard.writeText($8f82d61bec433391$var$toClipboardLink(this.downloadLink));
        const downloadLinkInput = this.renderRoot.getElementById('input-download-link');
        downloadLinkInput.focus();
        downloadLinkInput.select();
        downloadLinkInput.setSelectionRange(0, this.downloadLink.length);
        this.dispatchEvent(new CustomEvent('download-link-copied', {
            bubbles: true,
            composed: true
        }));
    }
    render() {
        // background-image for .upload-complete-form, kept out of static styles css since Parcel can't resolve data-url: inside it
        // alt text of upload-complete-form__image is empty because the image is decorative
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <form id="form-upload-complete" class="container-padding upload-complete-form" autocomplete="off" style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)({
            backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($47413cbc80342208$exports)))})`
        })}>
                <img class="upload-complete-form__image" src="${0, (/*@__PURE__*/$parcel$interopDefault($accae00d3388bae7$exports))}" alt="" width="230" height="230"/>
                <div class="upload-complete-form__right-side">
                    <p class="upload-complete-form__info">Your download link is ready:</p>
                    <div class="upload-complete-form__copy-area icon--hoverable mt-1rem">
                        <label class="visually-hidden" for="input-download-link">Download link: </label>
                        <input id="input-download-link" type="text" class="upload-complete-form__text-input" value="${this.downloadLink}" readonly @click=${this.#copyDownloadLink} @keyup=${this.#handleTextInputTabKeyUp} @blur=${this.#handleTextInputBlur} @keydown=${this.#handleKeyboardActivate}/>
                        <i id="button-copy" class="upload-complete-form__copy-button icon icon--copy" title="Copy to clipboard" aria-hidden="true" @click=${this.#copyDownloadLink}></i>
                    </div>
                    <button id="button-upload-another" class="upload-complete-form__upload-another mt-1rem mi-auto" type="button" @click=${this.#handleUploadAnotherClick}>
                        Upload Another
                        <i class="icon icon--rotate-right" aria-hidden="true"></i>
                    </button>
                </div>
            </form>
        `;
    }
}
customElements.define('tempup-form-upload-complete', $8f82d61bec433391$export$2e2bcd8739ae039);


// Duplicated from static/script/index.js (not imported — that script isn't a module).
// Visitors may reach the app via http(s):// and/or `www.<domain>` — normalize the
// displayed link to a bare host (scheme-less, no `www.`) so it's consistent and
// matches the scheme-less format used elsewhere (see static/index.html's placeholder value).
const $b36d2287265d0487$var$getDisplayOrigin = (origin)=>origin.replace(/^https?:\/\/(www\.)?/i, '');
// Ported from static/script/index.js's uploadChunk, plus an AbortSignal wired to
// xhr.abort() so #startUpload can cancel an in-flight chunk when a newer upload
// supersedes it.
const $b36d2287265d0487$var$uploadChunk = (uploadId, chunk, uploadedBytes, totalBytes, signal, onProgress)=>new Promise((resolve, reject)=>{
        const formData = new FormData();
        formData.append('chunk', chunk);
        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('progress', (e)=>{
            if (e.lengthComputable) onProgress(Math.round((uploadedBytes + e.loaded) / totalBytes * 100));
        });
        xhr.addEventListener('load', ()=>{
            if (xhr.status >= 200 && xhr.status < 300) try {
                resolve(JSON.parse(xhr.responseText));
            } catch (_error) {
                reject(new Error('Invalid chunk response.'));
            }
            else reject(new Error('Chunk upload failed.'));
        });
        xhr.addEventListener('error', ()=>reject(new Error('Chunk upload failed.')));
        xhr.addEventListener('abort', ()=>reject(new DOMException('Upload aborted.', 'AbortError')));
        signal.addEventListener('abort', ()=>xhr.abort());
        xhr.open('POST', `/upload/chunk/${uploadId}`);
        xhr.send(formData);
    });
class $b36d2287265d0487$var$UploadContainer extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    #uploadAbortController = null;
    // On upload-button-clicked (dispatched by tempup-form-upload, see
    // _plans/4.2-lit_form_upload_component.md Step 13), this ancestor owns the
    // cross-component visibility swap neither sibling can decide on its own.
    #handleUploadButtonClicked(e) {
        const selectedFile = e.target.selectedFile;
        if (!selectedFile) return;
        const progressDiv = this.renderRoot.querySelector('tempup-progress-div');
        e.target.hidden = true;
        progressDiv.hidden = false;
        progressDiv.fileName = selectedFile.name;
        progressDiv.focusProgressBar();
        // Announces the phase change; static/script/index.js listens on document and
        // reuses its own setHeaderVisibility to react — see _plans/4.5-lit_upload_container_component.md Step 7.
        this.dispatchEvent(new CustomEvent('upload-started', {
            bubbles: true,
            composed: true
        }));
        this.#startUpload(selectedFile);
    }
    // On upload-another-clicked (dispatched by tempup-form-upload-complete), reset
    // and re-show the form.
    #handleUploadAnotherClicked(e) {
        const formUpload = this.renderRoot.querySelector('tempup-form-upload');
        formUpload.reset();
        e.target.hidden = true;
        formUpload.hidden = false;
        formUpload.focusFileSelect();
        // See upload-started above — same events-up pattern, opposite direction.
        this.dispatchEvent(new CustomEvent('upload-reset', {
            bubbles: true,
            composed: true
        }));
    }
    // Cancels any upload already in flight before starting a new one, so "restart"
    // is an explicit decision (a fresh AbortController) rather than something inferred
    // from #handleUploadButtonClicked firing twice.
    async #startUpload(file) {
        this.#uploadAbortController?.abort();
        const abortController = new AbortController();
        this.#uploadAbortController = abortController;
        const progressDiv = this.renderRoot.querySelector('tempup-progress-div');
        progressDiv.progressValue = 0;
        try {
            const { uploadId: uploadId, allowedChunkSize: allowedChunkSize } = await fetch('/upload/init', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    filename: file.name,
                    fileSize: file.size
                }),
                signal: abortController.signal
            }).then((r)=>r.json());
            const totalChunks = Math.ceil(file.size / allowedChunkSize);
            let uploadedBytes = 0;
            for(let i = 0; i < totalChunks; i++){
                const chunk = file.slice(i * allowedChunkSize, (i + 1) * allowedChunkSize);
                await $b36d2287265d0487$var$uploadChunk(uploadId, chunk, uploadedBytes, file.size, abortController.signal, (percent)=>{
                    progressDiv.progressValue = percent;
                });
                uploadedBytes += chunk.size;
            }
            progressDiv.progressValue = 100;
            const formUploadComplete = this.renderRoot.querySelector('tempup-form-upload-complete');
            formUploadComplete.downloadLink = `${$b36d2287265d0487$var$getDisplayOrigin(window.location.origin)}/file/${uploadId}`;
            progressDiv.hidden = true;
            formUploadComplete.hidden = false;
            formUploadComplete.focusDownloadLink();
        } catch (error) {
            // A superseded upload rejects here too (uploadChunk's abort listener, or
            // fetch's own AbortSignal handling) — not a real failure, nothing to report.
            if (abortController.signal.aborted) return;
        // TODO: no failure UI yet — static/script/index.js's finishUpload('') path
        // (reset to the form, show the header again) isn't ported to the Lit
        // components yet. See plan's Known outstanding TODOs.
        }
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <tempup-form-upload @upload-button-clicked=${this.#handleUploadButtonClicked}></tempup-form-upload>
            <tempup-progress-div hidden></tempup-progress-div>
            <tempup-form-upload-complete hidden @upload-another-clicked=${this.#handleUploadAnotherClicked}></tempup-form-upload-complete>
        `;
    }
}
customElements.define("upload-container", $b36d2287265d0487$var$UploadContainer);


//# sourceMappingURL=static.5bc20366.js.map
